module.exports = __webpack_public_path__ + "static/img/003.e6097395.jpg";